import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.addPartner || initialState;

export const selectAddPartner = createSelector([selectSlice], state => state);
